// extracted by mini-css-extract-plugin
export default {"thumb":"thumb_thumb__SnvPL","is-round-8":"thumb_is-round-8__4W5pM","is-round-12":"thumb_is-round-12__XJpmn","is-circle":"thumb_is-circle__DjTn4"};